import { render, staticRenderFns } from "./Intangible.vue?vue&type=template&id=d6675f84&scoped=true&"
import script from "./Intangible.vue?vue&type=script&lang=js&"
export * from "./Intangible.vue?vue&type=script&lang=js&"
import style0 from "./Intangible.vue?vue&type=style&index=0&id=d6675f84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6675f84",
  null
  
)

export default component.exports